import { render, staticRenderFns } from "./ConfirmEditDialog.vue?vue&type=template&id=58555f87&"
import script from "./ConfirmEditDialog.vue?vue&type=script&lang=js&"
export * from "./ConfirmEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports